import React from 'react';
import { MarkdownRenderer } from '../../utils/markdownRenderer';
import './TermsOfService.css';

const termsContent = `# Nutzungsbedingungen für die Rudolf Steiner KI-Suche (Testversion)

## 1. Urheberrechtliche Situation
Die Texte Rudolf Steiners sind seit 1996 gemeinfrei, da die 70-jährige Schutzfrist abgelaufen ist. Die von der Rudolf Steiner Nachlassverwaltung herausgegebenen bearbeiteten Ausgaben der Gesamtausgabe bleiben jedoch urheberrechtlich geschützt. Die hier verwendeten Texte stammen aus einer autorisierten Zusammenarbeit mit dem Uranus Verein, AndroWiki und SteinerWiki.

## 2. Experimenteller Charakter
Diese Plattform befindet sich in der Testphase. Die KI-generierten Antworten basieren auf maschinell verarbeiteten Texten aus der Rudolf Steiner Gesamtausgabe und können:
- Fehler oder Ungenauigkeiten enthalten
- Fehlinterpretationen aufweisen
- Zusammenhänge unvollständig oder inkorrekt wiedergeben

## 3. Haftungsausschluss
- Der Betreiber übernimmt keine Haftung für die Richtigkeit, Vollständigkeit oder Aktualität der KI-generierten Inhalte
- Nutzer haften selbst für die Weiterverwendung der generierten Inhalte
- Es wird keine Gewähr für die korrekte Wiedergabe von Rudolf Steiners Gedanken übernommen
- Die Nutzung erfolgt auf eigenes Risiko
- Für eventuelle Schäden durch die Nutzung der Inhalte wird keine Haftung übernommen

## 4. Nutzungsbestimmungen
- Die Inhalte dienen ausschließlich zu Informations- und Testzwecken
- Bei Zitaten sollte stets auf die Originalquellen in der Rudolf Steiner Gesamtausgabe verwiesen werden
- Nutzer sind selbst verantwortlich für die Überprüfung der Inhalte vor jeder Weiterverwendung
- Die generierten Antworten ersetzen nicht das Studium der Originaltexte
- Kommerzielle Nutzung der Plattform ist ohne ausdrückliche Genehmigung untersagt

## 5. Datenschutzerklärung

### 5.1 Verantwortlicher
Verantwortlich für die Datenverarbeitung:
Arian Mingo  
Zum Weierle 4  
78333 Stockach-Wahlwies

### 5.2 Datenverarbeitung
- Für die KI-Funktionalität nutzen wir die Schnittstelle von Google (Gemini)
- **Wir speichern keine eingegebenen Daten auf unseren Servern**
- Laut den Google Cloud-Nutzungsbedingungen werden über die API übermittelte Daten nicht für Trainingszwecke verwendet

### 5.3 Lokale Speicherung im Browser
- Die Bookmark-Funktion speichert Daten **ausschließlich lokal in Ihrem Browser**
- Diese Daten sind nur auf dem genutzten Gerät und Browser verfügbar
- Bei Nutzung eines anderen Browsers oder Geräts sind die Daten nicht verfügbar
- Beim Löschen der Browser-Daten werden auch alle gespeicherten Bookmarks entfernt

**Wichtiger Hinweis:** Bei Nutzung eines fremden Computers werden Ihre Bookmarks auf diesem Gerät gespeichert, sobald Sie auf das Bookmark-Symbol klicken. Bitte löschen Sie in diesem Fall vor Verlassen des Geräts Ihre Browser-Daten.

### 5.4 Keine Cookies oder Tracking
Wir verwenden keine Cookies oder Tracking-Mechanismen zur Analyse Ihres Nutzungsverhaltens.

## 6. Technische Hinweise
- Die Qualität der Antworten hängt von der Präzision Ihrer Suchanfrage ab
- Komplexe philosophische Konzepte können von der KI möglicherweise vereinfacht dargestellt werden
- Bei wichtigen Recherchen konsultieren Sie bitte immer die Originalquellen

## 7. Keine Rechtsberatung oder verbindliche Interpretation
Die generierten Antworten stellen:
- Keine autorisierte Interpretation der Anthroposophie dar
- Keine Rechts-, Medizin- oder Lebensberatung dar
- Keine offizielle Position der Anthroposophischen Gesellschaft dar

## 8. Änderungen der Nutzungsbedingungen
Wir behalten uns vor, diese Nutzungsbedingungen bei Bedarf anzupassen. Änderungen werden auf dieser Seite veröffentlicht.

## 9. Impressum
**Verantwortlich für diese Website:**  
Arian Mingo  
Zum Weierle 4  
78333 Stockach-Wahlwies  
Deutschland

**Kontakt:**  
arian.mingo@sima.rocks

## 10. Schlussbestimmungen
Mit der Nutzung dieser Plattform erklären Sie sich mit diesen Bedingungen einverstanden und bestätigen, dass Sie:
- Den experimentellen Charakter des Dienstes verstehen
- Die Verantwortung für die Weiterverwendung der Inhalte selbst übernehmen
- Bei Unklarheiten die Originalquellen konsultieren werden

**Stand:** Juni 2025

---

*Diese Plattform ist ein unabhängiges Projekt und steht in keiner offiziellen Verbindung zur Allgemeinen Anthroposophischen Gesellschaft oder zum Rudolf Steiner Verlag.*`;

interface TermsOfServiceProps {
  open: boolean;
  onClose: () => void;
}

const TermsOfService: React.FC<TermsOfServiceProps> = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div className="terms-modal-overlay" onClick={onClose}>
      <div className="terms-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="terms-header">
          <h2>Nutzungsbedingungen</h2>
          <button className="terms-close-btn" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="terms-body">
          <MarkdownRenderer 
            content={termsContent}
            className="terms-content"
          />
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;